"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemType = exports.MenuItemOptionType = exports.MenuItemOccasion = exports.MenuItemGroupSizePackaging = exports.MenuItemAudience = exports.Meal = exports.Language = exports.InvoiceType = exports.InvoiceStatus = exports.InvoicePerOrderRecipientType = exports.InvoiceOrderForInput = exports.InvoiceConsolidationType = exports.InvoiceConsolidationFrequency = exports.GmServiceFormatInput = exports.GmOrdersSortTerm = exports.GmOrdersSortOrder = exports.GmOrdersDeliveryTimeFilterCondition = exports.GmOrderType = exports.GmOrderPricingAudience = exports.GmOrderPdfInputPdfType = exports.GmOrderPdfInputOrderType = exports.GmOrderFeeCode = exports.GmItemPackaging = exports.GmInvoicingFormat = exports.GmServiceFormat = exports.FlexInvoiceType = exports.FlexInvoiceStatus = exports.FlexInvoiceConsolidationFrequency = exports.EmmaRecipeTasteProfile = exports.EmmaFormTemperature = exports.EmmaFormServingType = exports.EmmaFormBudgetType = exports.EmmaBudgetType = exports.Dietary = exports.DeliveryStatus = exports.DeliveryBy = exports.DataAggregation = exports.Currency = exports.CountryCode = exports.Communications = exports.CerealSubAllergen = exports.BillingField = exports.BasketStatus = exports.AvailabilityServiceType = exports.AppArea = exports.Allergen = exports.AlertTypeFilterFieldType = exports.AlertFilterFieldType = exports.AccountOrderDirection = exports.AccountOrderByProperties = void 0;
exports.VendorOrderDirection = exports.VendorOrderByProperties = exports.VendorMarketplaceOrderByProperties = exports.VendorFlexInvoiceStatus = exports.VendorContactType = exports.Vehicle = exports.UserRole = exports.UserOrderDirection = exports.UserOrderByProperties = exports.UserFavouriteType = exports.TransportProfile = exports.TimePeriod = exports.TenantNavigationSubLinkType = exports.TenantImageUploadType = exports.Sort = exports.ServiceType = exports.RequiredTaxFields = exports.RegionType = exports.ReferenceFieldType = exports.Recurrence = exports.Protein = exports.PaymentType = exports.PaymentStatus = exports.PaymentSource = exports.PaymentMethod = exports.OrderType = exports.OrderServiceType = exports.OrderDirection = exports.OrderByProperties = exports.NutSubAllergen = exports.NotificationEventPushStatus = exports.NotificationEventEmailStatus = exports.Modules = void 0;
var AccountOrderByProperties;
(function (AccountOrderByProperties) {
    AccountOrderByProperties["Id"] = "id";
    AccountOrderByProperties["Name"] = "name";
    AccountOrderByProperties["OnboardingStatus"] = "onboardingStatus";
    AccountOrderByProperties["SignUpCode"] = "signUpCode";
})(AccountOrderByProperties = exports.AccountOrderByProperties || (exports.AccountOrderByProperties = {}));
var AccountOrderDirection;
(function (AccountOrderDirection) {
    AccountOrderDirection["Asc"] = "asc";
    AccountOrderDirection["Desc"] = "desc";
})(AccountOrderDirection = exports.AccountOrderDirection || (exports.AccountOrderDirection = {}));
var AlertFilterFieldType;
(function (AlertFilterFieldType) {
    AlertFilterFieldType["Boolean"] = "BOOLEAN";
    AlertFilterFieldType["String"] = "STRING";
})(AlertFilterFieldType = exports.AlertFilterFieldType || (exports.AlertFilterFieldType = {}));
var AlertTypeFilterFieldType;
(function (AlertTypeFilterFieldType) {
    AlertTypeFilterFieldType["Account"] = "ACCOUNT";
    AlertTypeFilterFieldType["Boolean"] = "BOOLEAN";
    AlertTypeFilterFieldType["Country"] = "COUNTRY";
    AlertTypeFilterFieldType["Dropdown"] = "DROPDOWN";
})(AlertTypeFilterFieldType = exports.AlertTypeFilterFieldType || (exports.AlertTypeFilterFieldType = {}));
var Allergen;
(function (Allergen) {
    Allergen["Celery"] = "celery";
    Allergen["Cereals"] = "cereals";
    Allergen["Crustaceans"] = "crustaceans";
    Allergen["Eggs"] = "eggs";
    Allergen["Fish"] = "fish";
    Allergen["Lupin"] = "lupin";
    Allergen["Milk"] = "milk";
    Allergen["Molluscs"] = "molluscs";
    Allergen["Mustard"] = "mustard";
    Allergen["None"] = "none";
    Allergen["Nuts"] = "nuts";
    Allergen["Peanuts"] = "peanuts";
    Allergen["Sesame"] = "sesame";
    Allergen["Soybeans"] = "soybeans";
    Allergen["Sulphur"] = "sulphur";
})(Allergen = exports.Allergen || (exports.Allergen = {}));
var AppArea;
(function (AppArea) {
    AppArea["Admin"] = "admin";
    AppArea["Ca"] = "ca";
    AppArea["User"] = "user";
    AppArea["Vendor"] = "vendor";
})(AppArea = exports.AppArea || (exports.AppArea = {}));
var AvailabilityServiceType;
(function (AvailabilityServiceType) {
    AvailabilityServiceType["Cc"] = "CC";
    AvailabilityServiceType["Gm"] = "GM";
})(AvailabilityServiceType = exports.AvailabilityServiceType || (exports.AvailabilityServiceType = {}));
var BasketStatus;
(function (BasketStatus) {
    BasketStatus["Ordered"] = "ordered";
    BasketStatus["Saved"] = "saved";
})(BasketStatus = exports.BasketStatus || (exports.BasketStatus = {}));
var BillingField;
(function (BillingField) {
    BillingField["AccountName"] = "accountName";
    BillingField["AccountNumber"] = "accountNumber";
    BillingField["BankCode"] = "bankCode";
    BillingField["BankName"] = "bankName";
    BillingField["BranchCode"] = "branchCode";
    BillingField["BsbNumber"] = "bsbNumber";
    BillingField["SortCode"] = "sortCode";
})(BillingField = exports.BillingField || (exports.BillingField = {}));
var CerealSubAllergen;
(function (CerealSubAllergen) {
    CerealSubAllergen["Barley"] = "barley";
    CerealSubAllergen["Kamut"] = "kamut";
    CerealSubAllergen["Oats"] = "oats";
    CerealSubAllergen["Rye"] = "rye";
    CerealSubAllergen["Wheat"] = "wheat";
})(CerealSubAllergen = exports.CerealSubAllergen || (exports.CerealSubAllergen = {}));
var Communications;
(function (Communications) {
    Communications["CustomerOnly"] = "customerOnly";
    Communications["NoCommunication"] = "noCommunication";
    Communications["VendorAndCustomer"] = "vendorAndCustomer";
    Communications["VendorOnly"] = "vendorOnly";
})(Communications = exports.Communications || (exports.Communications = {}));
var CountryCode;
(function (CountryCode) {
    CountryCode["Au"] = "AU";
    CountryCode["De"] = "DE";
    CountryCode["Gb"] = "GB";
    CountryCode["Ie"] = "IE";
    CountryCode["It"] = "IT";
    CountryCode["Nl"] = "NL";
    CountryCode["Nz"] = "NZ";
    CountryCode["Sg"] = "SG";
    CountryCode["Us"] = "US";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var Currency;
(function (Currency) {
    Currency["Aud"] = "AUD";
    Currency["Eur"] = "EUR";
    Currency["Gbp"] = "GBP";
    Currency["Nzd"] = "NZD";
    Currency["Sgd"] = "SGD";
    Currency["Usd"] = "USD";
})(Currency = exports.Currency || (exports.Currency = {}));
var DataAggregation;
(function (DataAggregation) {
    DataAggregation["Day"] = "DAY";
    DataAggregation["Week"] = "WEEK";
})(DataAggregation = exports.DataAggregation || (exports.DataAggregation = {}));
var DeliveryBy;
(function (DeliveryBy) {
    DeliveryBy["Feedr"] = "feedr";
    DeliveryBy["Vendor"] = "vendor";
})(DeliveryBy = exports.DeliveryBy || (exports.DeliveryBy = {}));
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["DriverAtDropoff"] = "driver_at_dropoff";
    DeliveryStatus["DriverAtPickup"] = "driver_at_pickup";
    DeliveryStatus["DriverEnRouteToPickup"] = "driver_en_route_to_pickup";
    DeliveryStatus["Failed"] = "failed";
    DeliveryStatus["InTransit"] = "in_transit";
    DeliveryStatus["LookingForDriver"] = "looking_for_driver";
    DeliveryStatus["Pending"] = "pending";
    DeliveryStatus["Success"] = "success";
})(DeliveryStatus = exports.DeliveryStatus || (exports.DeliveryStatus = {}));
var Dietary;
(function (Dietary) {
    Dietary["ContainsNuts"] = "containsNuts";
    Dietary["Halal"] = "halal";
    Dietary["HighProtein"] = "highProtein";
    Dietary["Kosher"] = "kosher";
    Dietary["LowCarb"] = "lowCarb";
    Dietary["LowCarbon"] = "lowCarbon";
    Dietary["NoDairy"] = "noDairy";
    Dietary["NoGluten"] = "noGluten";
    Dietary["NoRefinedSugar"] = "noRefinedSugar";
    Dietary["Pescatarian"] = "pescatarian";
    Dietary["PlantPacked"] = "plantPacked";
    Dietary["Vegan"] = "vegan";
    Dietary["Vegetarian"] = "vegetarian";
    Dietary["VeryLowCarbon"] = "veryLowCarbon";
})(Dietary = exports.Dietary || (exports.Dietary = {}));
var EmmaBudgetType;
(function (EmmaBudgetType) {
    EmmaBudgetType["Individual"] = "Individual";
    EmmaBudgetType["Total"] = "Total";
})(EmmaBudgetType = exports.EmmaBudgetType || (exports.EmmaBudgetType = {}));
var EmmaFormBudgetType;
(function (EmmaFormBudgetType) {
    EmmaFormBudgetType["PerHead"] = "PER_HEAD";
    EmmaFormBudgetType["Total"] = "TOTAL";
})(EmmaFormBudgetType = exports.EmmaFormBudgetType || (exports.EmmaFormBudgetType = {}));
var EmmaFormServingType;
(function (EmmaFormServingType) {
    EmmaFormServingType["Both"] = "BOTH";
    EmmaFormServingType["Individual"] = "INDIVIDUAL";
    EmmaFormServingType["Sharing"] = "SHARING";
})(EmmaFormServingType = exports.EmmaFormServingType || (exports.EmmaFormServingType = {}));
var EmmaFormTemperature;
(function (EmmaFormTemperature) {
    EmmaFormTemperature["Both"] = "BOTH";
    EmmaFormTemperature["Cold"] = "COLD";
    EmmaFormTemperature["Hot"] = "HOT";
})(EmmaFormTemperature = exports.EmmaFormTemperature || (exports.EmmaFormTemperature = {}));
var EmmaRecipeTasteProfile;
(function (EmmaRecipeTasteProfile) {
    EmmaRecipeTasteProfile["Balanced"] = "BALANCED";
    EmmaRecipeTasteProfile["MoreSavoury"] = "MORE_SAVOURY";
    EmmaRecipeTasteProfile["MoreSweet"] = "MORE_SWEET";
})(EmmaRecipeTasteProfile = exports.EmmaRecipeTasteProfile || (exports.EmmaRecipeTasteProfile = {}));
var FlexInvoiceConsolidationFrequency;
(function (FlexInvoiceConsolidationFrequency) {
    FlexInvoiceConsolidationFrequency["Daily"] = "DAILY";
    FlexInvoiceConsolidationFrequency["Fortnightly"] = "FORTNIGHTLY";
    FlexInvoiceConsolidationFrequency["Monthly"] = "MONTHLY";
    FlexInvoiceConsolidationFrequency["Quarterly"] = "QUARTERLY";
    FlexInvoiceConsolidationFrequency["Weekly"] = "WEEKLY";
    FlexInvoiceConsolidationFrequency["Yearly"] = "YEARLY";
})(FlexInvoiceConsolidationFrequency = exports.FlexInvoiceConsolidationFrequency || (exports.FlexInvoiceConsolidationFrequency = {}));
var FlexInvoiceStatus;
(function (FlexInvoiceStatus) {
    FlexInvoiceStatus["Paid"] = "Paid";
    FlexInvoiceStatus["Unpaid"] = "Unpaid";
})(FlexInvoiceStatus = exports.FlexInvoiceStatus || (exports.FlexInvoiceStatus = {}));
var FlexInvoiceType;
(function (FlexInvoiceType) {
    FlexInvoiceType["AdjustmentInvoice"] = "AdjustmentInvoice";
    FlexInvoiceType["Invoice"] = "Invoice";
})(FlexInvoiceType = exports.FlexInvoiceType || (exports.FlexInvoiceType = {}));
var GmServiceFormat;
(function (GmServiceFormat) {
    GmServiceFormat["Individual"] = "individual";
    GmServiceFormat["Sharing"] = "sharing";
})(GmServiceFormat = exports.GmServiceFormat || (exports.GmServiceFormat = {}));
var GmInvoicingFormat;
(function (GmInvoicingFormat) {
    GmInvoicingFormat["Monthly"] = "MONTHLY";
    GmInvoicingFormat["PerOrder"] = "PER_ORDER";
})(GmInvoicingFormat = exports.GmInvoicingFormat || (exports.GmInvoicingFormat = {}));
var GmItemPackaging;
(function (GmItemPackaging) {
    GmItemPackaging["Both"] = "both";
    GmItemPackaging["Individual"] = "individual";
    GmItemPackaging["Sharing"] = "sharing";
    GmItemPackaging["Unknown"] = "unknown";
})(GmItemPackaging = exports.GmItemPackaging || (exports.GmItemPackaging = {}));
var GmOrderFeeCode;
(function (GmOrderFeeCode) {
    GmOrderFeeCode["CreditCard"] = "creditCard";
    GmOrderFeeCode["Delivery"] = "delivery";
    GmOrderFeeCode["Product"] = "product";
})(GmOrderFeeCode = exports.GmOrderFeeCode || (exports.GmOrderFeeCode = {}));
var GmOrderPdfInputOrderType;
(function (GmOrderPdfInputOrderType) {
    GmOrderPdfInputOrderType["Draft"] = "draft";
    GmOrderPdfInputOrderType["Placed"] = "placed";
})(GmOrderPdfInputOrderType = exports.GmOrderPdfInputOrderType || (exports.GmOrderPdfInputOrderType = {}));
var GmOrderPdfInputPdfType;
(function (GmOrderPdfInputPdfType) {
    GmOrderPdfInputPdfType["Summary"] = "summary";
})(GmOrderPdfInputPdfType = exports.GmOrderPdfInputPdfType || (exports.GmOrderPdfInputPdfType = {}));
var GmOrderPricingAudience;
(function (GmOrderPricingAudience) {
    GmOrderPricingAudience["Customer"] = "customer";
    GmOrderPricingAudience["VendorPostCommission"] = "vendorPostCommission";
    GmOrderPricingAudience["VendorPreCommission"] = "vendorPreCommission";
})(GmOrderPricingAudience = exports.GmOrderPricingAudience || (exports.GmOrderPricingAudience = {}));
var GmOrderType;
(function (GmOrderType) {
    GmOrderType["BespokeEvents"] = "bespokeEvents";
    GmOrderType["OfflineMealPlan"] = "offlineMealPlan";
    GmOrderType["PantryFill"] = "pantryFill";
    GmOrderType["PopUps"] = "popUps";
    GmOrderType["ProductFees"] = "productFees";
    GmOrderType["Seasonal"] = "seasonal";
    GmOrderType["Standard"] = "standard";
})(GmOrderType = exports.GmOrderType || (exports.GmOrderType = {}));
var GmOrdersDeliveryTimeFilterCondition;
(function (GmOrdersDeliveryTimeFilterCondition) {
    GmOrdersDeliveryTimeFilterCondition["Gt"] = "gt";
    GmOrdersDeliveryTimeFilterCondition["Gte"] = "gte";
    GmOrdersDeliveryTimeFilterCondition["Lt"] = "lt";
    GmOrdersDeliveryTimeFilterCondition["Lte"] = "lte";
})(GmOrdersDeliveryTimeFilterCondition = exports.GmOrdersDeliveryTimeFilterCondition || (exports.GmOrdersDeliveryTimeFilterCondition = {}));
var GmOrdersSortOrder;
(function (GmOrdersSortOrder) {
    GmOrdersSortOrder["Asc"] = "asc";
    GmOrdersSortOrder["Desc"] = "desc";
})(GmOrdersSortOrder = exports.GmOrdersSortOrder || (exports.GmOrdersSortOrder = {}));
var GmOrdersSortTerm;
(function (GmOrdersSortTerm) {
    GmOrdersSortTerm["DeliveryTime"] = "deliveryTime";
})(GmOrdersSortTerm = exports.GmOrdersSortTerm || (exports.GmOrdersSortTerm = {}));
var GmServiceFormatInput;
(function (GmServiceFormatInput) {
    GmServiceFormatInput["Individual"] = "individual";
    GmServiceFormatInput["Sharing"] = "sharing";
})(GmServiceFormatInput = exports.GmServiceFormatInput || (exports.GmServiceFormatInput = {}));
var InvoiceConsolidationFrequency;
(function (InvoiceConsolidationFrequency) {
    InvoiceConsolidationFrequency["Fortnightly"] = "FORTNIGHTLY";
    InvoiceConsolidationFrequency["Monthly"] = "MONTHLY";
    InvoiceConsolidationFrequency["Weekly"] = "WEEKLY";
})(InvoiceConsolidationFrequency = exports.InvoiceConsolidationFrequency || (exports.InvoiceConsolidationFrequency = {}));
var InvoiceConsolidationType;
(function (InvoiceConsolidationType) {
    InvoiceConsolidationType["EndOfPeriod"] = "EndOfPeriod";
    InvoiceConsolidationType["PerOrder"] = "PerOrder";
})(InvoiceConsolidationType = exports.InvoiceConsolidationType || (exports.InvoiceConsolidationType = {}));
var InvoiceOrderForInput;
(function (InvoiceOrderForInput) {
    InvoiceOrderForInput["All"] = "ALL";
    InvoiceOrderForInput["Customer"] = "CUSTOMER";
    InvoiceOrderForInput["Supplier"] = "SUPPLIER";
})(InvoiceOrderForInput = exports.InvoiceOrderForInput || (exports.InvoiceOrderForInput = {}));
var InvoicePerOrderRecipientType;
(function (InvoicePerOrderRecipientType) {
    InvoicePerOrderRecipientType["InvoiceRecipients"] = "INVOICE_RECIPIENTS";
    InvoicePerOrderRecipientType["Requester"] = "REQUESTER";
    InvoicePerOrderRecipientType["RequesterAndInvoiceRecipients"] = "REQUESTER_AND_INVOICE_RECIPIENTS";
})(InvoicePerOrderRecipientType = exports.InvoicePerOrderRecipientType || (exports.InvoicePerOrderRecipientType = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Approved"] = "APPROVED";
    InvoiceStatus["Draft"] = "DRAFT";
    InvoiceStatus["Void"] = "VOID";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["Cc"] = "CC";
    InvoiceType["Gm"] = "GM";
})(InvoiceType = exports.InvoiceType || (exports.InvoiceType = {}));
var Language;
(function (Language) {
    Language["De"] = "de";
    Language["En"] = "en";
    Language["It"] = "it";
    Language["Nl"] = "nl";
})(Language = exports.Language || (exports.Language = {}));
var Meal;
(function (Meal) {
    Meal["Breakfast"] = "breakfast";
    Meal["Dinner"] = "dinner";
    Meal["Lunch"] = "lunch";
})(Meal = exports.Meal || (exports.Meal = {}));
var MenuItemAudience;
(function (MenuItemAudience) {
    MenuItemAudience["Customer"] = "CUSTOMER";
    MenuItemAudience["InternalAdmin"] = "INTERNAL_ADMIN";
})(MenuItemAudience = exports.MenuItemAudience || (exports.MenuItemAudience = {}));
var MenuItemGroupSizePackaging;
(function (MenuItemGroupSizePackaging) {
    MenuItemGroupSizePackaging["Individual"] = "INDIVIDUAL";
    MenuItemGroupSizePackaging["Sharing"] = "SHARING";
})(MenuItemGroupSizePackaging = exports.MenuItemGroupSizePackaging || (exports.MenuItemGroupSizePackaging = {}));
var MenuItemOccasion;
(function (MenuItemOccasion) {
    MenuItemOccasion["AfternoonTea"] = "afternoon_tea";
    MenuItemOccasion["Breakfast"] = "breakfast";
    MenuItemOccasion["Dinner"] = "dinner";
    MenuItemOccasion["Lunch"] = "lunch";
    MenuItemOccasion["MorningTea"] = "morning_tea";
})(MenuItemOccasion = exports.MenuItemOccasion || (exports.MenuItemOccasion = {}));
var MenuItemOptionType;
(function (MenuItemOptionType) {
    MenuItemOptionType["Numbers"] = "numbers";
    MenuItemOptionType["Ticks"] = "ticks";
})(MenuItemOptionType = exports.MenuItemOptionType || (exports.MenuItemOptionType = {}));
var MenuItemType;
(function (MenuItemType) {
    MenuItemType["Drink"] = "drink";
    MenuItemType["Main"] = "main";
    MenuItemType["Side"] = "side";
    MenuItemType["Unknown"] = "unknown";
})(MenuItemType = exports.MenuItemType || (exports.MenuItemType = {}));
var Modules;
(function (Modules) {
    Modules["MenuManager"] = "MENU_MANAGER";
})(Modules = exports.Modules || (exports.Modules = {}));
var NotificationEventEmailStatus;
(function (NotificationEventEmailStatus) {
    NotificationEventEmailStatus["Bounced"] = "BOUNCED";
    NotificationEventEmailStatus["Deferred"] = "DEFERRED";
    NotificationEventEmailStatus["Delivered"] = "DELIVERED";
    NotificationEventEmailStatus["Dropped"] = "DROPPED";
    NotificationEventEmailStatus["Processed"] = "PROCESSED";
    NotificationEventEmailStatus["Sent"] = "SENT";
})(NotificationEventEmailStatus = exports.NotificationEventEmailStatus || (exports.NotificationEventEmailStatus = {}));
var NotificationEventPushStatus;
(function (NotificationEventPushStatus) {
    NotificationEventPushStatus["Failed"] = "FAILED";
    NotificationEventPushStatus["Sent"] = "SENT";
})(NotificationEventPushStatus = exports.NotificationEventPushStatus || (exports.NotificationEventPushStatus = {}));
var NutSubAllergen;
(function (NutSubAllergen) {
    NutSubAllergen["Almonds"] = "almonds";
    NutSubAllergen["Brazil"] = "brazil";
    NutSubAllergen["Cashew"] = "cashew";
    NutSubAllergen["Hazelnuts"] = "hazelnuts";
    NutSubAllergen["Macadamia"] = "macadamia";
    NutSubAllergen["Pecan"] = "pecan";
    NutSubAllergen["Pistachio"] = "pistachio";
    NutSubAllergen["Walnuts"] = "walnuts";
})(NutSubAllergen = exports.NutSubAllergen || (exports.NutSubAllergen = {}));
var OrderByProperties;
(function (OrderByProperties) {
    OrderByProperties["CreatedAt"] = "createdAt";
    OrderByProperties["DueDate"] = "dueDate";
    OrderByProperties["PeriodEnd"] = "periodEnd";
    OrderByProperties["Total"] = "total";
})(OrderByProperties = exports.OrderByProperties || (exports.OrderByProperties = {}));
var OrderDirection;
(function (OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
var OrderServiceType;
(function (OrderServiceType) {
    OrderServiceType["BespokeEvents"] = "bespokeEvents";
    OrderServiceType["CloudCanteen"] = "cloudCanteen";
    OrderServiceType["OfflineMealPlan"] = "offlineMealPlan";
    OrderServiceType["PantryFill"] = "pantryFill";
    OrderServiceType["PopUps"] = "popUps";
    OrderServiceType["ProductFees"] = "productFees";
    OrderServiceType["Seasonal"] = "seasonal";
    OrderServiceType["Standard"] = "standard";
    OrderServiceType["UnknownValue"] = "unknownValue";
})(OrderServiceType = exports.OrderServiceType || (exports.OrderServiceType = {}));
var OrderType;
(function (OrderType) {
    OrderType["Cc"] = "CC";
    OrderType["Gm"] = "GM";
})(OrderType = exports.OrderType || (exports.OrderType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Card"] = "card";
    PaymentMethod["Invoice"] = "invoice";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
var PaymentSource;
(function (PaymentSource) {
    PaymentSource["Manual"] = "MANUAL";
    PaymentSource["Xero"] = "XERO";
})(PaymentSource = exports.PaymentSource || (exports.PaymentSource = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Overdue"] = "OVERDUE";
    PaymentStatus["Paid"] = "PAID";
    PaymentStatus["Unpaid"] = "UNPAID";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["Card"] = "Card";
    PaymentType["InvoiceAccount"] = "InvoiceAccount";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var Protein;
(function (Protein) {
    Protein["Beef"] = "beef";
    Protein["Fish"] = "fish";
    Protein["Lamb"] = "lamb";
    Protein["Plantbased"] = "plantbased";
    Protein["Pork"] = "pork";
    Protein["Poultry"] = "poultry";
    Protein["Shellfish"] = "shellfish";
})(Protein = exports.Protein || (exports.Protein = {}));
var Recurrence;
(function (Recurrence) {
    Recurrence["Fortnightly"] = "fortnightly";
    Recurrence["Monthly"] = "monthly";
    Recurrence["Weekly"] = "weekly";
})(Recurrence = exports.Recurrence || (exports.Recurrence = {}));
/** Reference field types will be added here as they are implemented. */
var ReferenceFieldType;
(function (ReferenceFieldType) {
    ReferenceFieldType["Dropdown"] = "DROPDOWN";
    ReferenceFieldType["FreeText"] = "FREE_TEXT";
    ReferenceFieldType["ValidatedInput"] = "VALIDATED_INPUT";
})(ReferenceFieldType = exports.ReferenceFieldType || (exports.ReferenceFieldType = {}));
var RegionType;
(function (RegionType) {
    RegionType["CustomPolygon"] = "custom_polygon";
    RegionType["CycleMinuteRadius"] = "cycle_minute_radius";
    RegionType["KilometerRadius"] = "kilometer_radius";
    RegionType["MileRadius"] = "mile_radius";
})(RegionType = exports.RegionType || (exports.RegionType = {}));
var RequiredTaxFields;
(function (RequiredTaxFields) {
    RequiredTaxFields["GstNumber"] = "gstNumber";
    RequiredTaxFields["VatNumber"] = "vatNumber";
})(RequiredTaxFields = exports.RequiredTaxFields || (exports.RequiredTaxFields = {}));
var ServiceType;
(function (ServiceType) {
    ServiceType["Cc"] = "cc";
    ServiceType["Gm"] = "gm";
})(ServiceType = exports.ServiceType || (exports.ServiceType = {}));
var Sort;
(function (Sort) {
    Sort["Asc"] = "asc";
    Sort["Desc"] = "desc";
})(Sort = exports.Sort || (exports.Sort = {}));
var TenantImageUploadType;
(function (TenantImageUploadType) {
    TenantImageUploadType["AssetAuthBackground"] = "ASSET_AUTH_BACKGROUND";
    TenantImageUploadType["AssetOrderConfirmation"] = "ASSET_ORDER_CONFIRMATION";
    TenantImageUploadType["AssetPlaceholder"] = "ASSET_PLACEHOLDER";
    TenantImageUploadType["EmailBannerUrl"] = "EMAIL_BANNER_URL";
    TenantImageUploadType["EmailBannerUrlAlt"] = "EMAIL_BANNER_URL_ALT";
    TenantImageUploadType["EmailBannerUrlAlt1"] = "EMAIL_BANNER_URL_ALT1";
    TenantImageUploadType["EmailLogo"] = "EMAIL_LOGO";
    TenantImageUploadType["LogoDefault"] = "LOGO_DEFAULT";
    TenantImageUploadType["LogoFavicon"] = "LOGO_FAVICON";
    TenantImageUploadType["LogoLoadingIndicator"] = "LOGO_LOADING_INDICATOR";
    TenantImageUploadType["LogoRainbow"] = "LOGO_RAINBOW";
    TenantImageUploadType["LogoWhite"] = "LOGO_WHITE";
})(TenantImageUploadType = exports.TenantImageUploadType || (exports.TenantImageUploadType = {}));
var TenantNavigationSubLinkType;
(function (TenantNavigationSubLinkType) {
    TenantNavigationSubLinkType["Callback"] = "callback";
    TenantNavigationSubLinkType["Cell"] = "cell";
    TenantNavigationSubLinkType["Link"] = "link";
    TenantNavigationSubLinkType["Redirect"] = "redirect";
})(TenantNavigationSubLinkType = exports.TenantNavigationSubLinkType || (exports.TenantNavigationSubLinkType = {}));
var TimePeriod;
(function (TimePeriod) {
    TimePeriod["Custom"] = "CUSTOM";
    TimePeriod["Monthly"] = "MONTHLY";
    TimePeriod["Quarterly"] = "QUARTERLY";
    TimePeriod["Weekly"] = "WEEKLY";
    TimePeriod["Yearly"] = "YEARLY";
})(TimePeriod = exports.TimePeriod || (exports.TimePeriod = {}));
var TransportProfile;
(function (TransportProfile) {
    TransportProfile["Cycling"] = "Cycling";
    TransportProfile["Driving"] = "Driving";
    TransportProfile["Walking"] = "Walking";
})(TransportProfile = exports.TransportProfile || (exports.TransportProfile = {}));
var UserFavouriteType;
(function (UserFavouriteType) {
    UserFavouriteType["Supplier"] = "SUPPLIER";
})(UserFavouriteType = exports.UserFavouriteType || (exports.UserFavouriteType = {}));
var UserOrderByProperties;
(function (UserOrderByProperties) {
    UserOrderByProperties["Account"] = "account";
    UserOrderByProperties["AccountLocation"] = "accountLocation";
    UserOrderByProperties["Email"] = "email";
    UserOrderByProperties["FirstName"] = "firstName";
    UserOrderByProperties["Id"] = "id";
    UserOrderByProperties["LastName"] = "lastName";
    UserOrderByProperties["Role"] = "role";
})(UserOrderByProperties = exports.UserOrderByProperties || (exports.UserOrderByProperties = {}));
var UserOrderDirection;
(function (UserOrderDirection) {
    UserOrderDirection["Asc"] = "asc";
    UserOrderDirection["Desc"] = "desc";
})(UserOrderDirection = exports.UserOrderDirection || (exports.UserOrderDirection = {}));
var UserRole;
(function (UserRole) {
    UserRole["Employee"] = "EMPLOYEE";
    UserRole["Manager"] = "MANAGER";
})(UserRole = exports.UserRole || (exports.UserRole = {}));
var Vehicle;
(function (Vehicle) {
    Vehicle["Bicycle"] = "bicycle";
    Vehicle["BicycleCargo"] = "bicycle_cargo";
    Vehicle["Car"] = "car";
    Vehicle["Large"] = "large";
    Vehicle["Medium"] = "medium";
    Vehicle["Motorcycle"] = "motorcycle";
    Vehicle["Small"] = "small";
    Vehicle["Van"] = "van";
    Vehicle["VanSmall"] = "van_small";
    Vehicle["Walk"] = "walk";
    Vehicle["Xlarge"] = "xlarge";
    Vehicle["Xsmall"] = "xsmall";
})(Vehicle = exports.Vehicle || (exports.Vehicle = {}));
var VendorContactType;
(function (VendorContactType) {
    VendorContactType["Finance"] = "finance";
    VendorContactType["Order"] = "order";
    VendorContactType["Other"] = "other";
    VendorContactType["Schedule"] = "schedule";
})(VendorContactType = exports.VendorContactType || (exports.VendorContactType = {}));
var VendorFlexInvoiceStatus;
(function (VendorFlexInvoiceStatus) {
    VendorFlexInvoiceStatus["Paid"] = "Paid";
    VendorFlexInvoiceStatus["Unpaid"] = "Unpaid";
})(VendorFlexInvoiceStatus = exports.VendorFlexInvoiceStatus || (exports.VendorFlexInvoiceStatus = {}));
var VendorMarketplaceOrderByProperties;
(function (VendorMarketplaceOrderByProperties) {
    VendorMarketplaceOrderByProperties["Alphabetical"] = "alphabetical";
    VendorMarketplaceOrderByProperties["Distance"] = "distance";
    VendorMarketplaceOrderByProperties["Favourites"] = "favourites";
    VendorMarketplaceOrderByProperties["Price"] = "price";
})(VendorMarketplaceOrderByProperties = exports.VendorMarketplaceOrderByProperties || (exports.VendorMarketplaceOrderByProperties = {}));
var VendorOrderByProperties;
(function (VendorOrderByProperties) {
    VendorOrderByProperties["CompanyName"] = "companyName";
    VendorOrderByProperties["Id"] = "id";
})(VendorOrderByProperties = exports.VendorOrderByProperties || (exports.VendorOrderByProperties = {}));
var VendorOrderDirection;
(function (VendorOrderDirection) {
    VendorOrderDirection["Asc"] = "asc";
    VendorOrderDirection["Desc"] = "desc";
})(VendorOrderDirection = exports.VendorOrderDirection || (exports.VendorOrderDirection = {}));
